// Copyright (c) 2025 Bytedance Ltd. and/or its affiliates
// SPDX-License-Identifier: MIT

import { Bike, Building, Film, Github, Ham, Home, Pizza } from "lucide-react";
import { Bot } from "lucide-react";

import { BentoCard } from "@/components/magicui/bento-grid";

import { SectionHeader } from "../components/section-header";

const caseStudies = [
  {
    id: "state_rnaseq.json",
    icon: Building,
    title: "RNA-seq测序分析(DEGs)",
    description:
      "RNA-seq是一种基于高通量测序技术的转录组分析方法，通过直接测定样本中所有RNA分子（如mRNA、非编码RNA等）的序列，全面反映基因表达水平、结构变异及功能信息。其核心流程包括：​​RNA提取与文库构建​​,​​高通量测序​​,​​数据分析​​（比对参考基因组、量化基因表达、识别差异表达基因等）",
  },
  {
    id: "state_wga.json",
    icon: Github,
    title: "全基因组分析（Whole Genome Analysis）",
    description:
      "全基因组分析以“测序→组装→变异检测→功能注释”为核心流程，通过解码遗传信息驱动精准医学、农业育种及病原监测等领域的突破。随着长读长测序与AI技术的融合，其分辨率与应用广度将持续提升。",
  },
  {
    id: "state_chipseq.json",
    icon: Ham,
    title: "ChIP-seq分析（染色质免疫共沉淀测序）",
    description:
      "ChIP-seq是一种用于研究蛋白质与DNA相互作用的高通量技术，结合染色质免疫沉淀（ChIP）和二代测序，可全基因组水平定位目标蛋白（如转录因子、组蛋白修饰）的结合位点。数据分析​​包括质控、比对、Peak识别、注释、Motif、富集分析",
  },
  {
    id: "state_scrnaseq.json",
    icon: Home,
    title: "单细胞测序（single cell sequencing）",
    description:
      "单细胞测序是一种在单个细胞水平上对基因组、转录组或表观基因组进行高通量测序的技术。它突破了传统群体细胞测序的局限，能够揭示细胞间的异质性（即细胞个体差异），为理解发育、疾病和生命过程提供了前所未有的分辨率。",
  },
  {
    id: "review-of-the-professional",
    icon: Film,
    title: "Introduce the movie 'Léon: The Professional'",
    description:
      "The research provides a comprehensive introduction to the movie 'Léon: The Professional', including its plot, characters, and themes.",
  },
  {
    id: "china-food-delivery",
    icon: Bike,
    title: "How do you view the takeaway war in China? (in Chinese)",
    description:
      "The research analyzes the intensifying competition between JD and Meituan, highlighting their strategies, technological innovations, and challenges.",
  },
  {
    id: "ultra-processed-foods",
    icon: Pizza,
    title: "Are ultra-processed foods linked to health?",
    description:
      "The research examines the health risks of rising ultra-processed food consumption, urging more research on long-term effects and individual differences.",
  },
  {
    id: "ai-twin-insurance",
    icon: Bot,
    title: 'Write an article on "Would you insure your AI twin?"',
    description:
      "The research explores the concept of insuring AI twins, highlighting their benefits, risks, ethical considerations, and the evolving regulatory.",
  },
];

export function CaseStudySection() {
  return (
    <div className="mt-16">
      <section className="relative container flex flex-col items-center justify-center">
        <SectionHeader
          anchor="case-studies"
          title="Case Studies"
          description="See BioAgent in action through replays."
        />
        <div className="grid w-full grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {caseStudies.map((caseStudy) => (
            <div key={caseStudy.title} className="w-full p-2">
              <BentoCard
                {...{
                  Icon: caseStudy.icon,
                  name: caseStudy.title,
                  description: caseStudy.description,
                  href: `/show?replay=${caseStudy.id}`,
                  cta: "Click to watch replay",
                  className: "w-full h-full",
                }}
              />
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
